import { Injectable, inject } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({ providedIn: 'root' })
export class HidePageGuard implements CanLoad {
  private readonly router = inject(Router);

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    this.router.navigate(['/']);

    return false;
  }
}
